import { openAiIntegrationApi, openAiIntegrationKeys } from '@client/api/waterlily';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useToast } from '@/components/hooks/use-toast';

export function useFetchCompletion(requestId: string) {
  const { errorToast } = useToast();

  const query = useQuery<OpenAiCompletionResponseDbRecord>({
    queryKey: openAiIntegrationKeys.detail(requestId),
    queryFn: () => openAiIntegrationApi.fetchCompletion(requestId),
    enabled: !!requestId,
  });

  useEffect(() => {
    if (query.isError) {
      errorToast('Failed to fetch underwriting results', 'Please try again.');
    }
  }, [query.isError, errorToast]);

  return query;
}
